<template>
  <JoszakiModal
    :open="isModalOpen"
    :title="$t('questionPage.deleteAnswerModal.title')"
    @close="closeModal"
  >
    <template #body>
      <JoszakiLoading :active="isDeleting" />
      <p>
        {{ $t("questionPage.deleteAnswerModal.info") }}
      </p>
    </template>

    <template #footer>
      <div class="flex flex-1 justify-between">
        <JoszakiButton @click="closeModal">
          {{ $t("common.cancel") }}
        </JoszakiButton>
        <JoszakiButton
          type="error"
          icon-left="exclamation-circle"
          @click="deleteAnswer"
        >
          {{ $t("questionPage.deleteAnswerModal.submitButton") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import {
  MODAL_DELETE_ANSWER,
  useQuestionStore,
} from "~/stores/question/question";

export default {
  name: "DeleteAnswerModal",
  setup() {
    return {
      questionStore: useQuestionStore(),
    };
  },
  data: () => {
    return {
      isDeleting: false,
    };
  },
  computed: {
    isModalOpen() {
      return this.questionStore.isModalOpen(MODAL_DELETE_ANSWER);
    },
    answer() {
      return this.questionStore.modalInput(MODAL_DELETE_ANSWER)?.answer ?? null;
    },
  },
  methods: {
    async deleteAnswer() {
      if (!this.answer) {
        throw new Error("No answer selected for delete answer modal.");
      }

      try {
        this.isDeleting = true;

        await this.questionStore.deleteAnswer(Number(this.answer.id));

        this.closeModal();
        await this.questionStore.reloadQuestion();

        this.$joszaki.toast({
          message: this.$t("questionPage.deleteAnswerModal.success"),
          position: "is-top",
          type: "success",
        });
      } catch (e) {
        this.$joszaki.toast({
          message: this.$t("questionPage.deleteAnswerModal.error"),
          position: "is-top",
          type: "danger",
        });
      } finally {
        this.isDeleting = false;
      }
    },
    closeModal() {
      this.questionStore.closeModal();
    },
  },
};
</script>
